const initialState = {
    users: [],
    userInfo: {
        role: 'Admin',
        avatar: '',
        createdby: '',
        displayname: '',
        email: '',
        firstname: '',
        lastlogin: '',
        lastname: '',
        middlename: '',
        password: '',
        phone: '',
        isAdmin: false,
        designation: 'loading',
        about: '',
        token: '',
    },
    error: {
        isOpen: false,
        message: 'Invalid Login Credentials',
    },
    userData: [],
    roleData: [],
    rolesConfigurations: [],
    applicationConfigurations: [],
    dashboardConfigurations: [],
    routesConfigurations: [],
    screenPermissions: [],
    onChangeCaptureRoutesConfiguration: {
        authorisedRoutes: [],
        unAuthorisedRoutes: [],
    },
    onChangeCaptureRoutePermissions: {},
    userDetails: {
        firstname: '',
    },
    userActivityLogs: [],
    allRolesDashboard: []
};

export default initialState;
